import { useState, useEffect } from 'react';

import { ACCESS_TOKEN_STORAGE_KEY } from 'src/constants';

export function ClientLayout({ children }: { children: React.ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false);

  /** 获取url access_token 参数注入到 localStorage 并设置 isInitialized 为 true */
  useEffect(() => {
    if (isInitialized) return;
    const accessToken = new URLSearchParams(window.location.search).get('access_token');
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, accessToken);
    }
    setIsInitialized(true);
  }, [isInitialized]);

  if (!isInitialized) return null;

  return <>{children}</>;
}
